import { WSService } from "../../../../utils/WSService";

export const monitorService = new WSService("/v2/insurance/monitor");
